import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const KineticLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const Reveal = ({ children, delay = 0, className = "", y = 48 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ number, text, dark = false }) => (
  <div className="flex items-center gap-4 mb-6" data-testid={`section-label-${number}`}>
    <span className={`text-xs tracking-[0.3em] font-medium ${dark ? "text-white/50" : "text-[#1D4ED8]"}`}>
      {number}
    </span>
    <span className={`h-px w-12 ${dark ? "bg-white/30" : "bg-[#0A1128]/20"}`} />
    <span className={`text-xs uppercase tracking-[0.3em] font-medium ${dark ? "text-white/50" : "text-[#475569]"}`}>
      {text}
    </span>
  </div>
);
